import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const THEMES = {
  dark: {
    name: 'Oscuro',
    key: 'dark',
    colors: {
      background: '222.2 47.4% 7.2%',
      foreground: '210 40% 98%',
      primary: '217.2 91.2% 59.8%',
      secondary: '217.2 32.6% 12.5%',
    }
  },
  light: {
    name: 'Claro',
    key: 'light',
    colors: {
      background: '0 0% 100%',
      foreground: '222.2 84% 4.9%',
      primary: '217.2 91.2% 59.8%',
      secondary: '210 40% 96.1%',
    }
  },
  blue: {
    name: 'Azul Profundo',
    key: 'blue',
    colors: {
      background: '222 47% 5%',
      foreground: '210 40% 98%',
      primary: '199 89% 48%',
      secondary: '217 32% 15%',
    }
  },
  emerald: {
    name: 'Esmeralda',
    key: 'emerald',
    colors: {
      background: '160 30% 6%',
      foreground: '210 40% 98%',
      primary: '160 84% 39%',
      secondary: '160 25% 12%',
    }
  },
  purple: {
    name: 'Púrpura',
    key: 'purple',
    colors: {
      background: '270 30% 7%',
      foreground: '210 40% 98%',
      primary: '270 91% 65%',
      secondary: '270 25% 14%',
    }
  }
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('dark');

  useEffect(() => {
    // Load saved theme
    const saved = localStorage.getItem('baluad-theme');
    if (saved && THEMES[saved]) {
      setCurrentTheme(saved);
    }
  }, []);

  useEffect(() => {
    // Apply theme to root
    const root = document.documentElement;
    const theme = THEMES[currentTheme];
    
    if (theme) {
      Object.entries(theme.colors).forEach(([key, value]) => {
        root.style.setProperty(`--${key}`, value);
      });
      
      // Add class for light/dark mode
      if (currentTheme === 'light') {
        root.classList.remove('dark');
        root.classList.add('light');
      } else {
        root.classList.remove('light');
        root.classList.add('dark');
      }
      
      localStorage.setItem('baluad-theme', currentTheme);
    }
  }, [currentTheme]);

  const changeTheme = (themeKey) => {
    if (THEMES[themeKey]) {
      setCurrentTheme(themeKey);
    }
  };

  return (
    <ThemeContext.Provider value={{ 
      currentTheme, 
      changeTheme, 
      themes: THEMES,
      isDark: currentTheme !== 'light'
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
